import { Box, styled } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "stretch",
  textAlign: 'center',
  justifyContent: "center",
}));

export const Item = styled(Box)(({ theme }) => ({
  whiteSpace: "nowrap",
  willChange: "transform",
}));
